import React,{useContext} from "react";
import { useNavigate } from "react-router-dom";
import { contextApiActions } from "../../../_redux/_constants";
import {
     ContentRightWr,
     MainLeftTitle,
     CreateButton,
} from "../../_uiComponents/WrapperComponents";
import DataTemplatesManagement from "./views/DataTemplatesManagement";
import CreateByFileImport from "./views/CreateByFileImport";
import { Context } from "../../../_context/Store";
import { useDispatch } from "react-redux";
import { dataTemplateTypeListRequest } from "../../../_redux/_actions";

export default function DataTemplatesWrapper() {
     const navigate = useNavigate();
     const [state, dispatch] = useContext(Context);
     const actionDispatch = useDispatch();

     const createByFileImport = () => {
          dispatch({
               type: contextApiActions.UI_EXTRA_LARGE_MODAL_TOGGEL,
               payload: {
                    show: true,
                    heading: "Create By File Import",
                    children: <CreateByFileImport/>,
               },
          });
     };

     return (
          <>
               <MainLeftTitle title="Data Templates Management">
                    <div className="sb-lookup-table-create-btn">
                         <CreateButton
                              name="Create"
                              onClick={() => {
                                   navigate("/app/data-templates-manage/add")
                              }}
                         />
                    </div>
                    <div className="sb-lookup-table-create-btn">
                         <CreateButton
                              name="Create By File Import"
                              onClick={createByFileImport}
                         />
                    </div>
                    
               </MainLeftTitle>
               
               <DataTemplatesManagement />
          </>
     );
}
